import React from "react";
import "../aseets/css/Navbar2.css";

const MegaMenu = ({ type, onClose }) => {
  /* ===== MENU CONTENT CONFIG ===== */
  const menuConfig = {
    products: {
      title: "Services",
      description:
        "End-to-end digital growth services designed to transform visibility into demand, and demand into measurable business outcomes.",
      sidebar: [
        "Growth Architecture",
        "Brand & Market Positioning",
        "Demand Generation",
        "Search & Visibility Systems",
        "Lifecycle Automation",
        "Performance Intelligence"
      ],
    },

    plugins: {
      title: "Plugins & Extensions",
      description:
        "Pre-built plugins to integrate identity with your favorite platforms",
      sidebar: [
        "WordPress Plugins",
        "Jenkins Plugins",
        "Jira & Confluence",
        "Moodle Plugins",
        "Custom SDKs",
      ],
    },

    pricing: {
      title: "Pricing Plans",
      description:
        "Flexible pricing for startups, enterprises & growing businesses",
      sidebar: [
        "Free Plan",
        "Standard Plan",
        "Premium Plan",
        "Enterprise",
        "Compare Plans",
      ],
    },

    resources: {
      title: "Resources",
      description:
        "Everything you need to learn, build and integrate faster",
      sidebar: [
        "Documentation",
        "API References",
        "Case Studies",
        "Whitepapers",
        "Webinars",
      ],
    },

    company: {
      title: "Company",
      description:
        "Learn more about our mission, people and values",
      sidebar: [
        "About Us",
        "Careers",
        "Partners",
        "Press & Media",
        "Contact",
      ],
    },
  };

  const currentMenu = menuConfig[type];

  if (!currentMenu) return null;

  return (
    <div className="mega-wrapper">
      <div className="mega-menu">
        {/* LEFT SIDEBAR */}
        <div className="mega-sidebar">
          {currentMenu.sidebar.map((item, index) => (
            <div
              key={item}
              className={`sidebar-item ${index === 0 ? "active" : ""}`}
            >
              {item}
            </div>
          ))}

          <div className="sidebar-footer">
            View Other {type.charAt(0).toUpperCase() + type.slice(1)} →
          </div>
        </div>

        {/* MAIN CONTENT */}
        <div className="mega-content">
          <div className="mega-header">
            <div>
              <h2>{currentMenu.title} →</h2>
              <p>{currentMenu.description}</p>
            </div>
            <div className="header-right">
              <span className="pricing">View Pricing →</span>
              <span className="close" onClick={onClose}>✕</span>
            </div>
          </div>

          <div className="mega-columns">
            {/* COLUMN 1 */}
            <div className="column">
              <h4>Growth Strategy & Performance</h4>

              <div className="feature">
                <h5>Growth Architecture</h5>
                <p>Designing scalable digital growth frameworks aligned with business objectives</p>
              </div>

              <div className="feature">
                <h5>Performance Marketing</h5>
                <p>ROI-driven paid media across Google, Meta & emerging platforms</p>
              </div>

              <div className="feature">
                <h5>Funnel Optimization</h5>
                <p>Turning traffic into qualified leads and measurable conversions</p>
              </div>

              <div className="feature">
                <h5>Analytics & Attribution</h5>
                <p>Data-backed insights to track what actually drives revenue</p>
              </div>

              <span className="explore">Explore Growth Strategy →</span>
            </div>

            {/* COLUMN 2 */}
            <div className="column">
              <h4>Brand, Content & Experience</h4>

              <div className="feature">
                <h5>Brand Positioning</h5>
                <p>Crafting clear brand narratives that differentiate and convert</p>
              </div>

              <div className="feature">
                <h5>UI/UX & Website Design</h5>
                <p>High-performance websites built for clarity, speed and scale</p>
              </div>

              <div className="feature">
                <h5>Content Systems</h5>
                <p>SEO-driven content engines that attract, engage and educate</p>
              </div>

              <div className="feature">
                <h5>Social Media Presence</h5>
                <p>Strategic content that builds authority and audience trust</p>
              </div>

              <span className="explore">Explore Brand Systems →</span>
            </div>

            {/* COLUMN 3 */}
            <div className="column integrations">
              <h4>Channels & Execution</h4>

              <ul>
                <li>Search Engine Optimization (SEO)</li>
                <li>Paid Media & Campaigns</li>
                <li>Influencer & Community Marketing</li>
                <li>Marketing Automation</li>
              </ul>

              <span className="explore">Explore Execution →</span>
            </div>
            {/* COLUMN 4 */}
            <div className="column integrations">
              <h4>Why Global Manch</h4>

              <ul>
                <li>✔ Proven growth frameworks</li>
                <li>✔ Industry-specific strategies</li>
                <li>✔ Transparent reporting & ROI focus</li>
                <li>✔ Senior-led execution</li>
              </ul>

              <span className="explore">Explore Execution →</span>

              <button className="partner-btn">Partner with us</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MegaMenu;
